import { Component, Story, Knobs } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  name: {
    default: true,
    editor: 'checkbox',
  },
  height: {
    default: '60px',
    editor: 'textbox',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-access-logo where you can change all the attributes',
  coreComponent: {
    html: `<tag-access-logo{{...knobs}}>
</tag-access-logo>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper: { jsx: `<TagAccessLogo{{...knobs}} />`, knobs: PlaygroundKnobs },
};

export const TagAccessLogoDocs: Component = {
  type: 'component',
  name: 'access-logo',
  description: 'Displays the Access Group logo',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'height',
      description: 'This controls the height of the logo',
      type: 'string',
      default: '30px',
    },
    {
      name: 'name',
      description: 'Whether to include "access" to the right of the logo',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [PlaygroundStory],
};
